import React, { useEffect, useState } from "react";
import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";

import axios from "axios";
import config from '../../config';
import client from '../../client';

const StripeCheckoutForm = (props) => {
  const [clientSecret, setClientSecret] = useState("");
  const [error, setError] = useState(false);
  const [stripePromise, setStripePromise] = useState(null);

  const { company } = props.selfProps;
  const companyName = company && company.name;
  const oID = `${companyName}${props.orderId}`;

  const initializeStripe = async () => {
    const { loadStripe } = await import("@stripe/stripe-js");

    const promise = loadStripe(config.stripeKey);
    setStripePromise(promise);
  };
  useEffect(() => {
    const createPaymentIntent = async () => {
      try{
          const { data } = await client().post(
          `${config.authAPI}/payment/stripePayment`,
          {
            amount: props.amount,
            currency: props.currency,
            orderId: oID
          }
        );
        setClientSecret(data.clientSecret);
      }catch(e){
        if (e.response) {
          console.log('Server Error Data:', e.response.data);
          console.log('Status Code:', e.response.status); 
          typeof e.response.data == 'string' ? setError(e.response.data) : setError('Error while getting payment request')
        } 
        else {
          console.log('Configuration Error:', e.message);
          setError(e.message)
        }
      }
    };
    initializeStripe()
    createPaymentIntent();
  }, []);

  if (!clientSecret) return <p>{error && typeof error == 'string' ? error : 'Loading...'}</p>;

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
      }}
    >
      <CheckoutForm orderId={oID} clientSecret={clientSecret} paymentConfig={props.paymentConfig} selfProps={props.selfProps}/>
    </Elements>
  );
}

const CheckoutForm = (props) => {

  const paymentConfig = props.paymentConfig;
  const selfProps = props.selfProps;
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setLoading(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: 'http://www.screenermonkey.com/app',
      },
      redirect: "if_required",
    });

    if (error) {
      console.log("error");
      client().post(`${config.authAPI}/payment/orderDetails`, {
          orderId: props.orderId
      }).then((orderDetailsResponse) => {
          orderDetailsResponse = orderDetailsResponse.data;
          const actualSubmit = selfProps.onHandleSubmit(values => {
              let payload = values;
              payload = setValue(payload, paymentConfig.paymentStatusField, 'failed');
              payload = setValue(payload, paymentConfig.declineCodeField, error.decline_code);
              payload = setValue(payload, paymentConfig.errorCodeField, error.code);
              payload = setValue(payload, paymentConfig.paymentReferenceField, error.payment_intent.id);
              payload = setValue(payload, paymentConfig.errorMessageField, error.message);
              selfProps.onSubmit(payload);
          });
          actualSubmit();
      }).catch((er) => {
          console.error(er);
      });
    } else {
      console.log("Payment Successful");
      client().post(`${config.authAPI}/payment/orderDetails`, {
          orderId: props.orderId
      }).then((orderDetailsResponse) => {
          orderDetailsResponse = orderDetailsResponse.data;
          const actualSubmit = selfProps.onHandleSubmit(values => {
              let payload = values;
              payload = setValue(payload, paymentConfig.paymentStatusField, paymentIntent.status);
              payload = setValue(payload, paymentConfig.paymentReferenceField, paymentIntent.id);
              
              selfProps.onSubmit(payload);
          });
          actualSubmit();
      }).catch((er) => {
          console.error(er);
      });
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      <button disabled={!stripe || loading}>
        {loading ? "Processing..." : "Pay"}
      </button>
    </form>
  );
}

const setValue = (payload,fieldKey, value) => {

    return fieldKey.indexOf('.') == -1 ? payload.set(fieldKey, value) : payload.setIn(fieldKey.split('.'), value) 
}

export default StripeCheckoutForm;